import { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faTrash, faImage } from '@fortawesome/free-solid-svg-icons';

import { Button } from '~ui-kit';
import { infoColor } from '~theme';
import { useToast } from '~features/toast';
import { uploadPhoto } from '../../services/api.helpers';

const PhotoAdder = props => {
  const [showPreview, setShowPreview] = useState(false);
  const toast = useToast();

  const onPhotoSuccess = photoDataURI => {
    try {
      const paddedData = `data:image/jpeg;base64,${photoDataURI}`;
      uploadPhoto({
        base64WithMeta: paddedData,
      }).then(res => {
        toast.success('Kuva ladattu');
        props.onPhotoChange({ id: res.id, photo: paddedData });
      });
    } catch (e) {
      console.log('Error while uploading photo', e);
      toast.error('Kuvan lataaminen palvelimelle epäonnistui');
    }
  };

  const onPhotoError = err => {
    console.log('Taking photo failed', err);
  };

  const handleRemove = () => {
    props.onPhotoChange(null);
    navigator.camera.cleanup();
  };

  const takePhoto = () => {
    const opts = {
      quality: 25,
      destinationType: window.Camera.DestinationType.DATA_URL,
      correctOrientation: true,
      saveToPhotoAlbum: false,
    };

    navigator.camera.getPicture(onPhotoSuccess, onPhotoError, opts);
  };

  const togglePreview = () => {
    setShowPreview(!showPreview);
  };

  const { photoData } = props;

  return (
    <PhotoAdderWrapper>
      {photoData ? (
        <ImgRow>
          <ImgName>liitekuva.jpg</ImgName>
          <IconButton onClick={togglePreview}>
            <Icon icon={faImage} />
            katso kuva
          </IconButton>
          <IconButton onClick={handleRemove}>
            <Icon icon={faTrash} />
            poista
          </IconButton>
        </ImgRow>
      ) : (
        <Button w="100%" onClick={takePhoto}>
          <Icon icon={faCamera} />
          Lisää kuva
        </Button>
      )}

      {photoData && showPreview && (
        <ImagePreview onClick={togglePreview}>
          <Img src={photoData} />
        </ImagePreview>
      )}
    </PhotoAdderWrapper>
  );
};

const PhotoAdderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: var(--field-width);
`;
const ImgRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const ImgName = styled.div`
  flex: 1;
  font-size: 14px;
  color: ${infoColor};
`;
const IconButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 16px;
  padding: 4px 6px;
  border-radius: 3px;
  border: 1px solid #ccc;
  font-size: 12px;
`;
const Icon = styled(FontAwesomeIcon)`
  margin-right: 6px;
`;
const ImagePreview = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Img = styled.img`
  width: 90%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.6);
`;

export default PhotoAdder;
